import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";

export const getRetailerOrBrandCountry = (): string => {
  const retailerCountry = getRetailer()?.country;
  const brandCountry = getBrand()?.based_in;
  return retailerCountry ?? brandCountry ?? "";
};
